import { Box, Grid, Stack, InputAdornment, Typography, TextField, Accordion, AccordionSummary, AccordionDetails, IconButton, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Tooltip } from '@mui/material';
import SearchIcon from 'common/customIcons/search';
import MDButton from 'components/MDButton';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import { CloseRounded } from '@mui/icons-material';
import { useDebounce } from 'hooks/useDebounce';
import { useSearchParams } from 'react-router-dom';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import EditIcon from "common/customIcons/edit";
import DeleteIcon from "common/customIcons/delete";
import { deleteShopTimeSlot, fetchShopTimeList } from '../../../../redux/slices/hyperwolf/settings';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { convertToAmPm } from 'utilities/common';
import { closeCustomModalDialog, openCustomModalDialog, setModalLoader } from '../../../../redux/slices/modalSlice';
import { openSnackbar } from '../../../../redux/slices/common';
import Loader from 'common/Loader';
import NoDataFound from 'common/component/NoDataFound';
import { getPermissionsByMode } from 'utilities/common';
import { hasSectionPermission } from 'utilities/common';
import { getData } from 'utilities/common';

const GeneralTiming = () => {
    const [searchTerm, setSearchTerm] = useState("");
    const searchTermRef = useRef('');
    const [searchParams, setSearchParams] = useSearchParams();
    const dispatch = useDispatch()
    const { loading, shopTimingData } = useSelector(state => state.hyperwolfSettings);
    const { user } = useSelector(state => state.auth);


    let localUser = getData('login-user-info')
    if (localUser) {
        localUser = JSON.parse(localUser)
    }

    const adminMode = localStorage.getItem("adminsMode") ? JSON.parse(localStorage.getItem("adminsMode")) : null;
    const permissionsForMode = getPermissionsByMode(localUser?.permissions, adminMode);

    const canCreate = hasSectionPermission(permissionsForMode, "Settings", "Create");
    const canEdit = hasSectionPermission(permissionsForMode, "Settings", "Edit/Update");
    const canView = hasSectionPermission(permissionsForMode, "Settings", "View Only");
    const canDelete = hasSectionPermission(permissionsForMode, "Settings", "Delete");

    // Function to sort days in correct weekly order
    const sortDaysByWeekOrder = (shopTimeArray) => {
        const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

        return shopTimeArray?.sort((a, b) => {
            const dayAIndex = dayOrder.indexOf(a.day);
            const dayBIndex = dayOrder.indexOf(b.day);
            return dayAIndex - dayBIndex;
        });
    };

    // Get sorted shop timing data
    const sortedShopTimingData = useMemo(() => {
        if (!shopTimingData?.shopTime) return shopTimingData;

        return {
            ...shopTimingData,
            shopTime: sortDaysByWeekOrder([...shopTimingData.shopTime])
        };
    }, [shopTimingData]);

    const searchHandler = (event) => {
        setSearchTerm(event);
        searchTermRef.current = event;
        handleSearch(event);
        // Debounce the search callback
    };

    const handleSearch = useDebounce(() => {
        dispatch(fetchShopTimeList({ searchTerm: searchTermRef.current }))
            .unwrap()
            .then((res) => {
            })
            .catch((err) => {
            });
    }, 500);

    const deleteHandler = (id) => {
        const payload = {
            updatedBy: user?.name,
        }

        dispatch(setModalLoader(true));
        dispatch(deleteShopTimeSlot({ id, payload })).unwrap().then((res) => {
            showResponseMessage(res?.data?.message, 'success');
            dispatch(fetchShopTimeList());
            dispatch(closeCustomModalDialog());
        }).catch((err) => {
            dispatch(setModalLoader(false));
            showResponseMessage(err?.message, 'error');
        });

    };

    const showResponseMessage = (message, errortype) => {
        if (errortype === 'success') {
            dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
        }
        if (errortype === 'error') {
            dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
        }
    };
    useEffect(() => {
        dispatch(fetchShopTimeList());
    }, [])



    return (
        <Box p={{ xs: 2, sm: 3, lg: 4 }} className="row-cursor time-slot-management" >
            {/* {loading && <Box style={{ position: "absolute" }}><Riple color='#3135cc' size='medium' text='' textColor='' /></Box>
            } */}
            <Grid container alignItems="center" spacing={2} mb={3}>
                <Grid item xs={12}>
                    <div className='w-100 d-flex align-item-center jc-s-btwn gap-2 page-res-head'>
                        <Typography variant='h4' color="#2E2E3A">
                            Delivery Hours
                            <Tooltip
                                title={
                                    <React.Fragment>
                                        <Typography variant='body2' className="text-12 d-flex align-item-center jc-s-btwn gap-2">
                                            The hours are set by day, allowing different opening/closing times.
                                        </Typography>
                                        <Typography variant='body2' className="text-12 d-flex align-item-center jc-s-btwn gap-2">
                                            All displayed times are calculated and enforced based on your business&apos;s primary registered time zone/region.
                                        </Typography>

                                    </React.Fragment>
                                }
                                arrow
                                placement="top"
                            >
                                <InfoOutlinedIcon color='#2E2E3A' style={{ color: '#2E2E3A', marginLeft: '5px', width: '18px', height: '18px' }} />
                            </Tooltip>
                        </Typography>
                        <Stack direction="row" justifyContent={{ xs: 'start', sm: 'end' }} flexWrap="wrap" alignItems="stretch" gap={2}>
                            <TextField className="custom-search-field" placeholder="Search" label="" value={searchTerm} onChange={(e) => searchHandler(e.target.value)}
                                InputProps={{
                                    startAdornment: <InputAdornment position="start">
                                        <IconButton size='small'>
                                            <SearchIcon width='18px' height='18px' />
                                        </IconButton>
                                    </InputAdornment>,
                                    endAdornment: searchTerm?.length > 0 ? <InputAdornment>
                                        <IconButton onClick={() => searchHandler('')} size='small'>
                                            <CloseRounded />
                                        </IconButton>
                                    </InputAdornment> : null
                                }}
                                style={{ minWidth: "300px" }}
                            />
                            {
                                canView &&
                                <MDButton
                                    onClick={() => { setSearchParams({ roleTab: `shopTimingLogs` }); }}
                                    variant="contained"
                                    color="warning"
                                    sx={{ minWidth: "180px", background: "#2E2E3A !important", boxShadow: "none !important" }}
                                >
                                    Activity Log
                                </MDButton>
                            }
                            {canCreate &&
                                shopTimingData?.shopTime?.length !== 7 &&

                                <MDButton
                                    startIcon={<AddRoundedIcon fontSize='large' />}
                                    variant="contained"
                                    color="primary"
                                    onClick={() => { setSearchParams({ roleTab: `creategeneralTimings` }); }}
                                    sx={{ minWidth: "180px" }}
                                >
                                    Add Timing
                                </MDButton>
                            }
                        </Stack>
                    </div>
                </Grid>
            </Grid>
            {canView &&
                loading ?
                <Loader />
                :
                <Grid container alignItems="center" spacing={2}>
                    {
                        shopTimingData?.shopTime?.length === 0 ?
                            <div style={{ margin: "auto" }}>  <NoDataFound /></div>
                            :
                            <Grid item xs={12}>
                                <div className="table-with-accordion">
                                    <div className="cus-table-header">
                                        <Typography className="field-acc-icon"></Typography>
                                        <Typography className="field-second">Days</Typography>
                                        <Typography className="field-fourth">Open Time</Typography>
                                        <Typography className="field-fifth">Close Time</Typography>
                                        <Typography className="field-actions">Action</Typography>
                                    </div>

                                    <div className="cus-table-body">
                                        {sortedShopTimingData?.shopTime?.map((data) => (
                                            <Accordion elevation={0} key={data}>
                                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                    <div className="cus-table-header">
                                                        <Typography className="field-second">{data?.day}</Typography>
                                                        <Typography className="field-fourth">{data?.defaultTime?.startTime ? convertToAmPm(data?.defaultTime?.startTime) : "-"}</Typography>
                                                        <Typography className="field-fifth">{data?.defaultTime?.endTime ? convertToAmPm(data?.defaultTime?.endTime) : "-"}</Typography>
                                                        <Typography className="field-actions">
                                                            <Box display="flex" alignItems="center" justifyContent="flex-end" className="m-0">
                                                                <IconButton
                                                                   disabled={!canEdit}
                                                                    color="primary"
                                                                    size="small"
                                                                    variant="primary"
                                                                    onClick={(e) => { e.stopPropagation(); setSearchParams({ roleTab: `editgeneralTimings`, editid: data?._id }) }}
                                                                >
                                                                    <EditIcon width="16px" height="16px" />
                                                                </IconButton>

                                                            </Box>
                                                        </Typography>
                                                    </div>
                                                </AccordionSummary>

                                                <AccordionDetails sx={{ p: 0 }}>
                                                    <TableContainer sx={{ maxHeight: 400 }}>
                                                        <Table stickyHeader aria-label="time slots table">
                                                            <TableHead sx={{ backgroundColor: "#f7f7fa" }}>
                                                                <TableRow>
                                                                    <TableCell sx={{ color: "grey.600", fontSize: "0.75rem", py: 1, minWidth: "350px" }}>Regions</TableCell>
                                                                    <TableCell sx={{ color: "grey.600", fontSize: "0.75rem", py: 1, minWidth: "250px" }}>Open Time</TableCell>
                                                                    <TableCell sx={{ color: "grey.600", fontSize: "0.75rem", py: 1, minWidth: "250px" }}>Close Time</TableCell>
                                                                    <TableCell
                                                                        align="right"
                                                                        sx={{ color: "grey.600", fontSize: "0.75rem", py: 1, minWidth: "150px" }}
                                                                    >
                                                                        Actions
                                                                    </TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>

                                                                {data?.slots?.length === 0 ? <TableRow>
                                                                    <TableCell colSpan={4} className="table-no-data">
                                                                        <NoDataFound />
                                                                    </TableCell>
                                                                </TableRow> : data?.slots?.map((daysData) => {
                                                                    return (
                                                                        <TableRow key={daysData}>
                                                                            <TableCell sx={{ minWidth: "350px" }}>
                                                                                <Typography variant="body2" color="#2E2E3A">{daysData?.regionName}</Typography>
                                                                            </TableCell>
                                                                            <TableCell sx={{ minWidth: "250px" }}>
                                                                                <Typography variant="body2" color="#2E2E3A">{convertToAmPm(daysData?.openTime)}</Typography>
                                                                            </TableCell>
                                                                            <TableCell sx={{ minWidth: "250px" }}>
                                                                                <Typography variant="body2" color="#2E2E3A">{convertToAmPm(daysData?.closeTime)}</Typography>
                                                                            </TableCell>
                                                                            <TableCell align="right" sx={{ minWidth: "150px" }}>
                                                                                <Box display="flex" alignItems="center" justifyContent="flex-end" className="m-0">

                                                                                    <IconButton
                                                                                    disabled={!canDelete}
                                                                                        color="error"
                                                                                        size="small"
                                                                                        variant="primary"
                                                                                        sx={{ marginLeft: 1 }}
                                                                                        onClick={() =>
                                                                                            dispatch(openCustomModalDialog({ modalData: { deleteHandler, deleteId: { slotid: daysData?._id, dayID: data?._id } }, modal: 'DELETE_MODAL' }))
                                                                                        }
                                                                                    >
                                                                                        <DeleteIcon width="16px" height="16px" />
                                                                                    </IconButton>
                                                                                </Box>
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    )

                                                                }
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </AccordionDetails>
                                            </Accordion>
                                        ))}
                                    </div>
                                </div>
                            </Grid>
                    }
                </Grid>
            }
        </Box>
    )
}

export default GeneralTiming